module.exports = __webpack_public_path__ + "static/starburst-c78bb2778273e5649016d67c3dd8979c.svg";